import { getInstance, DOMAIN_ENV, domain } from '@finance/domain'
import { APP, RUN_APP } from '@common/loan-act/env'

// 当前环境
export const ENV = getInstance().env


// 是否正式环境
export const isPROD = ENV === DOMAIN_ENV.PROD || ENV === DOMAIN_ENV.OUTER_PROD

// 获取神像云域名
const getWsDomain = () => {
  switch (ENV) {
    case DOMAIN_ENV.PROD:
    case DOMAIN_ENV.OUTER_PROD:
      return 'https://yunres.feidee.com'
    case DOMAIN_ENV.UAT:
      return 'https://yunuatres.feidee.com'
    default:
      return domain.res
  }
}
export const wsDomain = getWsDomain()

/** app内部自动识别code */
export const ACT_CODE = (() => {
  const code = {
    [APP.ssj]: 'selfloan_invitation_202103_ssj',
    [APP.kn]: 'selfloan_invitation_202103_ssj'
  }
  return code[RUN_APP]
})()

export const rechargePackages: any[] = [
  {
    planType: 3,
    productName: '账本免广告+无限次流水导出（一年）',
    limit: '1年',
    realPrice: 99,
    originPrice: 720,
    priceUnit: '贝/年',
    description: '账本免广告+无限次流水导出',
    purchased: false
  },
  {
    planType: 2,
    productName: '账本免广告+无限次流水导出（三个月）',
    limit: '3个月',
    realPrice: 49,
    originPrice: 180,
    priceUnit: '贝/季',
    description: '',
    purchased: false
  },
  {
    planType: 1,
    productName: '账本免广告+无限次流水导出（一个月）',
    limit: '1个月',
    realPrice: 29,
    originPrice: 60,
    priceUnit: '贝/月',
    description: '',
    purchased: false
  }
]

export const questions = [
  {
    title: '1.神象云年卡套餐购前须知'
  },
  {
    title: '2.神象云年卡套餐有什么优势？'
  },
  {
    title: '3.如何创建或升级神象云账本？'
  },
  // {
  //   title: '4.关于免广告服务的说明'
  // },
  // {
  //   title: '5.关于流水导出的说明'
  // },
]

const getDefaultBookTemplateId = () => {
  switch (ENV) {
    case DOMAIN_ENV.PROD:
    case DOMAIN_ENV.OUTER_PROD:
    case DOMAIN_ENV.FEIDEE_PROD:
    case DOMAIN_ENV.UAT:
      return '595573797749784577'
    default:
      return '435808876174688257'
  }
}
// 默认账本模板id
export const BOOK_TEMPLATE_ID = getDefaultBookTemplateId()
